import React, { Suspense } from 'react'
import Card from '../../../../../../components/Card'
import Body from './Body'
import List from './List'
import { faPencil } from '@fortawesome/free-solid-svg-icons'
import EditModel from './EditModal'
import useToggleState from 'src/hooks/useToggleState'

interface StatusProps {
  id: string
}

const Status: React.FC<StatusProps> = (props) => {
  const { id } = props
  const [isOpen, , handleToggle] = useToggleState()
  return (
    <Card
      title='Status'
      primaryAction={{
        key: 'edit-candidate-details',
        icon: faPencil,
        onClick: handleToggle,
        permissionKey: 'CAT_EDIT'
      }}

    >
      <Suspense fallback={<List candidate={undefined} />}>
        <Body id={id} />
      </Suspense>
      <EditModel id={id} isOpen={isOpen} toggle={handleToggle} />
    </Card>
  )
}

export default Status
